import React, { useState } from "react";
import Result from "./Result";
import "./Box.css";

const Box = (props) => {
  
  return (
    <div className="box" onClick={() => {
                props.setemail(props.email);
                props.setchoice(() => {
                  let newArray = new Array(props.questions.length).fill(0);
                   return newArray;
                });
                props.setquestion(props.questions);
                props.setinx(props.inx);
               
    }}>
        {props.name}
    </div>
  );
};

export default Box;
